import React, { ReactNode } from 'react';
import { BenefitAddOnV2 } from './components/BenefitAddOnV2';
import { Container } from '../../../../components/Container';
import { SectionHeading } from '../../../../components/SectionHeading';
import { WELLNESS_ADD_ON_DETAILS } from '../../../../data/wellness-add-ons';
import { Flex } from '../../../../wag-react/next-components/Flex';
export type WellnessAddOnsSectionV2Props = {
  onHelpIconClick: (name: string, description: ReactNode) => void;
};
export const WellnessAddOnsSectionV2 = ({
  onHelpIconClick
}: WellnessAddOnsSectionV2Props) => <Container my={4} textAlign="center" data-sentry-element="Container" data-sentry-component="WellnessAddOnsSectionV2" data-sentry-source-file="index.tsx">
    <SectionHeading fontSize={['24px', null, '30px']} my="24px" data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
      Plus up to four add-ons
    </SectionHeading>
    <Flex flexDirection="column" flexWrap={['nowrap', 'wrap']} maxHeight={['300px', '300px', '200px']} justifyContent="center" justifyItems="center" alignItems="center" alignContent="center" my={['32px', '16px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      {WELLNESS_ADD_ON_DETAILS.map(({
      description,
      name
    }) => <BenefitAddOnV2 key={name} description={description} name={name} onHelpIconClick={onHelpIconClick} mb="8px" width={['100%', '100%', '500px']} />)}
    </Flex>
  </Container>;